import firebase from "firebase/app";

import "firebase/firestore";
import "firebase/auth";
import "firebase/storage";

var config = ''
if (process.env.NODE_ENV !== 'production') {
  //testing and development
  console.log('loaded ' + process.env.NODE_ENV)
  config = {
    apiKey: "AIzaSyBWzh3pjrpS24AycSqk-Dze1X4AmHw_DKQ",
    authDomain: "alamsari-1dbe3.firebaseapp.com",
    projectId: "alamsari-1dbe3",
    storageBucket: "alamsari-1dbe3.appspot.com",
    messagingSenderId: "89478372862",
    appId: "1:89478372862:web:b3254233020e1668cdb4af"
  };

} else {
  //production
  console.log('loaded ' + process.env.NODE_ENV)
  config = {
    apiKey: "AIzaSyBWzh3pjrpS24AycSqk-Dze1X4AmHw_DKQ",
    authDomain: "alamsari-1dbe3.firebaseapp.com",
    projectId: "alamsari-1dbe3",
    storageBucket: "alamsari-1dbe3.appspot.com",
    messagingSenderId: "89478372862",
    appId: "1:89478372862:web:b3254233020e1668cdb4af"
  };
}

const app = firebase.initializeApp(config);
const db = firebase.firestore(app);
const auth = firebase.auth();
const storr = firebase.storage();
const fb = firebase;
// const settings = {/* your settings... */ timestampsInSnapshots: true };
// db.settings(settings);

export {
  auth,
  db,
  storr,
  app,
  fb
};




// WEBPACK FOOTER //
// ./src/firebase/firebase.js